import { tv } from 'tailwind-variants'

export const retentionDialogHeaderTitleVariants = tv({
  base: ['mt-4', 'font-formula text-center text-xl font-bold uppercase'],
  variants: {
    accentColor: {
      none: '',
      yellow: 'text-dark-yellow',
      green: 'text-green',
      blue: 'text-blue',
      pink: 'text-pink-flamingo'
    }
  },
  defaultVariants: {
    accentColor: 'yellow'
  }
})
